import { render, staticRenderFns } from "./UnifiedSearch.vue?vue&type=template&id=6baad704&scoped=true&"
import script from "./UnifiedSearch.vue?vue&type=script&lang=ts&"
export * from "./UnifiedSearch.vue?vue&type=script&lang=ts&"
import style0 from "./UnifiedSearch.vue?vue&type=style&index=0&id=6baad704&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6baad704",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCardText,VCardTitle,VCol,VContainer,VImg,VList,VListItem,VRow})
